import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Button,
  FormControl,
  FormLabel,
  OutlinedInput,
  Rating,
  FormHelperText,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Body from "../layouts/Body";
// import { questions, sections } from "../constants/constants";
import { useNavigate } from "react-router-dom";
import { useMenteeContext } from "../context/MenteeContext";
import { Loading } from "../components";
import { Breakpoint } from "../utils/theme";
import {
  getObservationQuestions,
  saveFeedback,
  updateMeetingSchedulerStatusandBatchName,
} from "../utils/services";
import { useUserContext } from "../context/UserContext";
import { currentQuater } from "../utils/validation";
import { enqueueSnackbar } from "notistack";
import {
  allowedChars,
  questionType,
  specialChars,
} from "../constants/constants";
import { getBatchDetails, getModuleDetails } from "../utils/services";

const Observation = () => {
  const [state, setState] = useState({});
  const [loading, setLoading] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [remarkData, setRemarkData] = useState({});
  const [batchList, setBatchList] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [sections, setSections] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [moduleName, setModuleName] = useState("");
  const [moduleList, setModuleList] = useState([]);

  const navigate = useNavigate();
  const {
    mentee,
    scheduleList,
    getMenteeSchedules,
    clearMenteeData,
    updateDashboardData,
  } = useMenteeContext();
  const { user } = useUserContext();

  const isMob = Breakpoint();
  const quarter = currentQuater();

  const handleRatingChange = (e, newValue) => {
    const name = e.target.name;
    setState((oldState) => ({
      ...oldState,
      [name]: {
        comments: oldState[name]?.comments || "",
        rating: newValue,
      },
    }));
  };

  const handleCommentChange = (e) => {
    const { name, value } = e.target;
    setState((oldState) => ({
      ...oldState,
      [name]: {
        comments: value,
        rating: oldState[name]?.rating,
      },
    }));
  };

  const handleBatchChange = (e) => {
    const selected = batchList.find((b) => b.batchId === e.target.value);
    setSelectedBatch(selected);
    setModuleName("");
    setModuleList([]);
  };

  const handleSave = async () => {
    if (Object.values(state).filter((val) => val.rating).length < 13) {
      enqueueSnackbar(
        "Ratings are not saved. In order to save the rating, kindly mark ratings for at least 13 observations.",
        { variant: "error" }
      );
      return;
    }

    if (
      Object.values(state)
        .filter((val) => val.rating)
        .some((val) => val.comments.length < 50)
    ) {
      enqueueSnackbar(
        "Ratings are not saved. In order to save the rating, Please add comments of minimum 50 characters for at least 13 observations.",
        { variant: "error" }
      );
      return;
    }

    if (remarks.length < 100) {
      enqueueSnackbar(
        "Please add Additional Comments of minimum 100 characters.",
        {
          variant: "error",
        }
      );
      return;
    }

    setLoading(true);
    let ansList = Object.keys(state)
      .filter((ans) => state[ans].rating)
      .map((key) => {
        let quest = questions.filter((ques) => ques.questionId == key);
        return {
          menteeId: mentee.id,
          questionId: Number(key),
          answer: state[key].rating,
          feedbackFor: quest[0].questionFor,
          quaterName: quarter,
          feedbackType: quest[0].questionType,
          createdBy: user.id,
          ratingComments: state[key].comments,
        };
      });

    ansList.push({
      menteeId: mentee.id,
      questionId: remarkData.questionId,
      answer: remarks,
      feedbackFor: remarkData.questionFor,
      quaterName: quarter,
      feedbackType: remarkData.questionType,
      createdBy: user.id,
      ratingComments: null,
    });

    const response = await saveFeedback(user.token, ansList);
    if (response.status == 200 || response.status == 201) {
      let schedule = scheduleList.filter(
        (schedule) => schedule.menteeId == mentee.id
      )[0];

      schedule.updatedBy = user.id;
      schedule.sessionStatus = "Observed";

      const res = await updateMeetingSchedulerStatusandBatchName(
        user.token,
        schedule.id,
        {
          sessionStatus: schedule.sessionStatus,
          batchName: selectedBatch?.batchName || "",
          moduleName: moduleList.length
            ? moduleList.find((m) => m.id === moduleName)?.name
            : moduleName,
        }
      );

      if (res.status == 200 || res.status == 201) {
        updateDashboardData();
        await getMenteeSchedules();
        enqueueSnackbar(
          `Classroom observations successfully captured for ${mentee.name}`,
          {
            variant: "success",
          }
        );
        setLoading(false);
        navigate("/schedule");
        clearMenteeData();
      } else {
        enqueueSnackbar("Fail to update status. Please try again later.", {
          variant: "error",
        });
        setLoading(false);
      }
    } else {
      enqueueSnackbar("Fail to save observation. Please try again later.", {
        variant: "error",
      });
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/schedule");
  };

  const getQuestions = async () => {
    const response = await getObservationQuestions(
      user.token,
      mentee.programId
    );

    if (response.status == 200) {
      // remove remarks question for question list and replace _ with space for questionType
      setRemarkData(
        response.data.filter((q) => q.questionType == questionType.remarks)[0]
      );
      let quest = response.data
        .filter((q) => q.questionType != questionType.remarks)
        .map((q) => {
          q.section = q.questionType.split("_").join(" ");
          return q;
        });

      setQuestions(quest);

      // get all sections for the data
      let section_list = [...new Set(quest.map((ques) => ques.section))];
      setSections(section_list);
    }
  };

  const getBatches = async () => {
    try {
      const batches = await getBatchDetails(user.token, mentee.id);
      if (batches?.length > 0) {
        setBatchList(batches);
      } else {
        enqueueSnackbar("No active batches found", {
          variant: "error",
        });
      }
    } catch (error) {
      enqueueSnackbar("Error loading batches", {
        variant: "error",
      });
    }
  };

  const getModules = async () => {
    if (!selectedBatch?.courseId) return;

    try {
      const modules = await getModuleDetails(
        user.token,
        selectedBatch.courseId
      );
      if (modules?.length > 0) {
        setModuleList(modules);
      } else {
        enqueueSnackbar("No modules found for this batch.", {
          variant: "info",
        });
      }
    } catch (error) {
      enqueueSnackbar("Failed to fetch modules", {
        variant: "error",
      });
    }
  };

  useEffect(() => {
    getQuestions();
    getBatches();
  }, []);

  useEffect(() => {
    getModules();
  }, [selectedBatch]);

  return (
    <Body>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={isMob ? "center" : "space-between"}
        sx={{ mb: 2 }}
      >
        <Typography variant="h5" className="page-title" color="primary">
          Observation For {mentee.name} - {mentee.programName}
        </Typography>
        {!isMob && (
          <Stack spacing={2} direction="row">
            <Button
              color="success"
              variant="contained"
              disabled={
                Object.values(state).filter((val) => val.rating).length < 13 ||
                Object.values(state)
                  .filter((val) => val.rating)
                  .some((val) => val.comments.length < 50) ||
                remarks.length < 100 ||
                specialChars.test(remarks) ||
                !selectedBatch?.batchId ||
                !moduleName
              }
              onClick={handleSave}
            >
              Save
            </Button>
            <Button color="error" variant="contained" onClick={handleCancel}>
              Cancel
            </Button>
          </Stack>
        )}
      </Stack>
      <Stack direction={isMob ? "column" : "row"} spacing={2} sx={{ mb: 2 }}>
        <FormControl fullWidth size="small">
          <FormLabel>Active Batch</FormLabel>
          <Select
            value={selectedBatch?.batchId || ""}
            onChange={handleBatchChange}
            displayEmpty
          >
            <MenuItem value="">Select Active Batch</MenuItem>
            {batchList.map((batch) => (
              <MenuItem key={batch.batchId} value={batch.batchId}>
                {batch.batchName}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth size="small" disabled={!selectedBatch}>
          <FormLabel>Module</FormLabel>
          {moduleList.length == 0 ? (
            <OutlinedInput
              placeholder="Enter Module Name"
              value={moduleName}
              onChange={(e) => setModuleName(e.target.value)}
            />
          ) : (
            <Select
              value={moduleName}
              onChange={(e) => setModuleName(e.target.value)}
              displayEmpty
            >
              <MenuItem value="">Select Module</MenuItem>
              {moduleList.map((mod) => (
                <MenuItem key={mod.id} value={mod.id}>
                  {mod.name}
                </MenuItem>
              ))}
            </Select>
          )}
        </FormControl>
      </Stack>

      <TableContainer component={Paper}>
        <Table aria-label="observation-table">
          <TableHead>
            <TableRow>
              <TableCell>Parameter</TableCell>
              <TableCell>Rating</TableCell>
              <TableCell>Comments</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sections.map((section) => {
              return (
               <React.Fragment key={section}>
                  <TableRow
                    key={section}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      bgcolor: "primary.main",
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      colSpan={3}
                      sx={{ fontWeight: 500, color: "white" }}
                    >
                      {section}
                    </TableCell>
                  </TableRow>
                  {questions
                    .filter((question) => question.section == section)
                    .map((row) => {
                      return (
                        <TableRow
                          key={row.questionId}
                          sx={{
                            "&:last-child td, &:last-child th": { border: 0 },
                          }}
                        >
                          <TableCell component="th" scope="row">
                            {row.question}
                          </TableCell>
                          <TableCell>
                            <Rating
                              precision={0.5}
                              name={row.questionId.toString()}
                              value={state[row.questionId]?.rating || 0}
                              onChange={handleRatingChange}
                              key={row.questionId.toString()}
                            />
                          </TableCell>

                          <TableCell>
                            <FormControl
                              size="small"
                              error={
                                state[row.questionId]?.rating
                                  ? state[row.questionId].comments.length < 50
                                  : false
                              }
                            >
                              <OutlinedInput
                                placeholder="Enter comment"
                                disabled={!state[row.questionId]?.rating}
                                name={row.questionId.toString()}
                                value={state[row.questionId]?.comments || ""}
                                onChange={handleCommentChange}
                                key={row.questionId.toString()}
                                inputProps={{ minLength: 50, maxLength: 500 }}
                              />
                            </FormControl>
                          </TableCell>
                        </TableRow>
                      );
                    })}
      </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <FormControl required fullWidth size="small" margin="normal">
        <FormLabel>Additional Comments</FormLabel>
        <OutlinedInput
          required
          multiline
          minRows={4}
          maxRows={10}
          value={remarks}
          onChange={(e) => setRemarks(e.target.value)}
          inputProps={{ minLength: 100, maxLength: 500 }}
        />

        {remarks.length < 100 && (
          <FormHelperText sx={{ color: "red", marginLeft: 0 }}>
            Minimum 100 characters required.
          </FormHelperText>
        )}

        {specialChars.test(remarks) && (
          <FormHelperText sx={{ color: "red", marginLeft: 0 }}>
            Special Characters like {specialChars.toString().slice(1, -1)} are
            not allowed. Special charaters like{" "}
            {allowedChars.toString().slice(1, -1)} are allowed.
          </FormHelperText>
        )}
      </FormControl>

      <h2 className="guidelines">Guidelines for CO</h2>
      <ol>
        <li>
          FSC (Facilitator Support Champion) can leave the parameter blank in
          case it is “Not Applicable”.
        </li>
        <li>Only 2 parameters can be left blank. (Not applicable)</li>
        <li>Add comment to each parameter. (Min. 50 characters)</li>
        <li>
          The Active Batch and Module must be Selected Before Submitting the
          Form.
        </li>
        <li>
          Add overall additional comments in the bottom box to enable the ‘
          Save’ button. (Min. 100 Characters)
        </li>
      </ol>

      <Stack spacing={2} direction="row" sx={{ mt: 2 }}>
        <Button
          fullWidth={isMob}
          color="success"
          variant="contained"
          disabled={
            Object.values(state).filter((val) => val.rating).length < 13 ||
            Object.values(state)
              .filter((val) => val.rating)
              .some((val) => val.comments.length < 50) ||
            remarks.length < 100 ||
            specialChars.test(remarks) ||
            !selectedBatch?.batchId ||
            !moduleName
          }
          onClick={handleSave}
        >
          Save
        </Button>
        <Button
          fullWidth={isMob}
          color="error"
          variant="contained"
          onClick={handleCancel}
        >
          Cancel
        </Button>
      </Stack>

      <Loading open={loading} />
    </Body>
  );
};

export default Observation;
